import { storageService } from 'js/services/storage.service';
import { type AnyAction, type MiddlewareAPI, type Dispatch } from 'redux';

export const user = (api: MiddlewareAPI) => (next: Dispatch<AnyAction>) => (action: AnyAction) => {
    if (action.type.startsWith('USER:')) {
        const { hasBeenLoggedIn } = api.getState().user || {};

        storageService.session.setItem('user', { hasBeenLoggedIn });
    }

    return next(action);
};
